import type { VoidFunctionComponent } from 'react';
import FallbackImage from '../../generic/FallbackImage';
import type { AsyncStatus } from '../../../types';

type Props = Required<{
  errors: AsyncStatus['errors'];
}>;

/**
 * IssueDetailsFullPageErrors displays a fallback image for
 * cases where there is some kind of error on the full-page issue details page.
 *
 * This would sometimes happen if the user is not allowed to view the issue,
 * or other issues such as network problems.
 */
const IssueDetailsFullPageErrors: VoidFunctionComponent<Props> = ({
  errors,
}) => {
  const isNotFound = errors?.find(error => error.toString().toLowerCase().includes('not found'));

  if (isNotFound) {
    return (
      <FallbackImage
        src="no-results"
        alt="Issue could not be found"
        hasPadding
      >
        Issue not found
      </FallbackImage>
    );
  }

  return (
    <FallbackImage
      src="error-plug"
      alt="Error fetching issue"
      hasPadding
    >
      Error fetching issue
    </FallbackImage>
  );
};

export default IssueDetailsFullPageErrors;
